import React from 'react';
import { Link } from 'react-router-dom';
import styles from './style.module.css';

export default function Button(props) {
  const {
    // must be filled: label, color, onClick (mandatory)
    label,
    color,
    onClick,

    // Optional
    className,
    type,
    blockBtn,
    smallBtn,
    disabled,

    // link button (type='link)
    // internal link
    href,
    // external link
    isExternal,
    target,
  } = props;

  // conditional styling (blockBtn/not), (smallBtn/not, etc)
  function colorStyle(colour) {
    if (colour === 'primary') {
      return styles.primary;
    }
    if (colour === 'secondary') {
      return styles.secondary;
    }
    if (colour === 'red') {
      return styles.red;
    }
    if (colour === 'green-white') {
      return styles.greenWhite;
    }
    return colour === 'white' ? styles.white : '';
  }

  const classesRoot = [
    styles.root,
    smallBtn && styles.smallBtn,
    blockBtn && styles.blockBtn,
    colorStyle(color),
  ].join(' ');

  const classes = [classesRoot, className].filter(Boolean).join(' ');

  if (type === 'link') {
    if (isExternal) {
      return (
        <a
          href={href}
          className={classes}
          target={target === '_blank' && '_blank'}
          rel={target === '_blank' && 'noopener noreferrer'}
        >
          {label}
        </a>
      );
    } else {
      return (
        <Link to={href} className={classes} onClick={onClick}>
          {label}
        </Link>
      );
    }
  }

  return (
    <button
      className={classes}
      onClick={onClick}
      type={type}
      disabled={disabled}
    >
      {label}
    </button>
  );
}
